import "../css/DividingLine.css";

const DividingLine = () => {
  return <div className="dividing-line"></div>;
};

export default DividingLine;
